import src from "IMAGE";
export default { src, width: 271, height: 61, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AFUSDEk3DAgwRBINTj8SDlBGEw9WOxAMRi8KByo0CwgvAH4bE3KDHBN0gBwTc24YEGF5GhJraRcQWnQZEWZxGBFmgmMNLgZWKn4AAAAASUVORK5CYII="};
